/* =====================================================================
 * Chat Model Store — 통합/문서 에이전트 입력창 모델 선택
 *
 * B2C 모델은 AI tenant manifest의 agent_default 역할과 일치시킨다.
 * ===================================================================== */

import { create } from 'zustand';
import i18n from '@auw/i18n';

export type ChatModelId = 'gemini-3.8-flash';

export interface ChatModelOption {
  id: ChatModelId;
  label: string;
  description: string;
  disabled: boolean;
}

export const DEFAULT_CHAT_MODEL: ChatModelId = 'gemini-3.8-flash';

const CHAT_MODEL_STORAGE_KEY = 'askyourai.chat.model';

const SELECTABLE_CHAT_MODELS = new Set<ChatModelId>(['gemini-3.8-flash']);

export function getChatModelOptions(): ChatModelOption[] {
  return [{
    id: 'gemini-3.8-flash', label: 'Gemini 3.8 Flash',
    description: i18n.t('common:chatModel.defaultModel', { defaultValue: '기본 모델' }),
    disabled: false,
  }];
}

function isSelectableChatModel(value: string | null): value is ChatModelId {
  return value !== null && SELECTABLE_CHAT_MODELS.has(value as ChatModelId);
}

function readStoredChatModel(): ChatModelId {
  try {
    const stored = localStorage.getItem(CHAT_MODEL_STORAGE_KEY);
    if (isSelectableChatModel(stored)) return stored;
  } catch {
    /* storage 접근 실패는 무시 */
  }
  return DEFAULT_CHAT_MODEL;
}

function persistChatModel(next: ChatModelId): void {
  try {
    localStorage.setItem(CHAT_MODEL_STORAGE_KEY, next);
  } catch {
    /* storage 접근 실패는 무시 */
  }
}

interface ChatModelState {
  model: ChatModelId;
  setModel: (model: ChatModelId) => void;
}

export const useChatModelStore = create<ChatModelState>((set) => ({
  model: readStoredChatModel(),
  setModel: (model) => {
    if (!SELECTABLE_CHAT_MODELS.has(model)) return;
    persistChatModel(model);
    set({ model });
  },
}));
